import ClientAboutBasic from '@/pages/client/pages/about/pages/basic'
import ClientAboutBackgrounds from '@/pages/client/pages/about/pages/backgrounds'
import ClientAboutGuardians from '@/pages/client/pages/about/pages/guardians'
import ClientAboutSurvey from '@/pages/client/pages/about/pages/survey'
const ROOT = ''
export default {
  routes: [
    {
      path: ROOT + 'basic',
      name: 'ClientAboutBasic',
      meta: {
        group: 'clientAbout',
        requireAuth: true,
        icon: ['fal', 'fa-user'],
        label: '基本情報',
        permit: 'about'
      },
      component: ClientAboutBasic
    },
    {
      path: ROOT + 'guardians',
      name: 'ClientAboutGuardians',
      meta: {
        group: 'clientAbout',
        requireAuth: true,
        icon: ['fal', 'fa-users'],
        label: '保護者',
        permit: 'about'
      },
      component: ClientAboutGuardians
    },
    {
      path: ROOT + 'backgrounds',
      name: 'ClientAboutBackgrounds',
      meta: {
        group: 'clientAbout',
        requireAuth: true,
        icon: ['fal', 'fa-list-ul'],
        label: '補足情報',
        permit: 'about'
      },
      component: ClientAboutBackgrounds
    },
    {
      path: ROOT + 'survey',
      name: 'ClientAboutSurvey',
      meta: {
        group: 'clientAbout',
        requireAuth: true,
        icon: ['fal', 'fa-clipboard-list-check'],
        label: 'アンケート',
        permit: 'about'
      },
      component: ClientAboutSurvey
    }
  ]
}
